import styles from './Workspaces.module.css'

import React, { useEffect, useState } from 'react'
import { Spin, Menu, Dropdown, Popconfirm } from 'antd'
import { removeUserSession } from '../../utils/sessionManagement'
import { useNavigate } from 'react-router-dom'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import {
  WorkspacesAPI,
  duplicateFormAPI,
  deleteFormAPI,
  TemplatesAPI,
  CreateFormFromTemplate,
} from '../../services/api'
import {
  getIsAdmin,
  getUser,
  getUsernameUser,
} from '../../utils/sessionManagement'
import RenderForm from '../../components/RenderForm/RenderForm'
import { useRef, useCallback } from 'react'
import { SvgSearchHome, SvgCloseIcon } from '../../components/svg/SvgComponents'
import Header from '../../components/Header/Header'
import {
  SvgMoreIconCanva,
  SvgGoLeft,
  SvgGoRight,
} from '../../components/svg/SvgComponents'

function Workspaces() {
  const history = useNavigate()
  const handleLogOut = () => {
    removeUserSession()
    console.log('handleLogOut')
    history('/login')
  }

  const flag = useRef(false)

  const isAdmin = getIsAdmin()

  const [templates, setTemplates] = useState([])

  const [searchQuery, setSearchQuery] = useState('')

  const [filters, setFilters] = useState({
    order_by: '-updated_at',
    title: '',
    updated_by: '',
    date: '',
    view_mode: 'viewClassic',
  })

  const [workspaces, setWorkspaces] = useState([])
  const [loading, setLoading] = useState(true)

  const [loadingTemplate, setLoadingTemplate] = useState(false)

  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const observer = useRef()

  const lastWorkspaceElementRef = useCallback(
    (node) => {
      if (loading) return
      if (observer.current) observer.current.disconnect()
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1)
        }
      })
      if (node) observer.current.observe(node)
    },
    [loading, hasMore]
  )

  function getPermissionForWorkspace(workspace) {
    // Trouver le collaborateur correspondant à l'utilisateur actuel.
    const currentUser = workspace.collaborators.find(
      (collaborator) => collaborator.username === 'ortizr'
    ) // À remplacer par le nom d'utilisateur actuel
    return currentUser?.permission
  }

  const fetchTemplates = async () => {
    try {
      const response = await TemplatesAPI()
      setTemplates(response.results)
      setLoadingTemplate(true)
    } catch (error) {
      console.error(error)
      setTemplates([])
      setLoadingTemplate(true)
    }
  }

  const fetchWorkspaces = async () => {
    try {
      const response = await WorkspacesAPI(page, filters)
      setWorkspaces((prevWorkspaces) => [
        ...prevWorkspaces,
        ...response.results,
      ])
      setHasMore(response.next !== null) // Check if there's a next page
      setLoading(false)
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    if (flag.current === false) {
      fetchTemplates()
    }

    return () => (flag.current = true)
  }, [])

  useEffect(() => {
    fetchWorkspaces()
  }, [page, filters])

  const handleOrderByChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      order_by: value === 'Du plus récent' ? '-updated_at' : 'updated_at',
    }))
    setPage(1)
    setWorkspaces([]) // Reset the list when changing filter
    setLoading(true) // Set loading to true here
  }

  const handleReset = () => {
    searchInputRef.current.value = ''
    setSearchQuery('')
    setFilters({
      order_by: '-updated_at',
      title: '',
      updated_by: '',
      date: '',
      view_mode: 'viewClassic',
      // Omettez le paramètre view_mode pour le réinitialiser
    })
    setPage(1)
    setWorkspaces([])
    setLoading(true)
  }

  const handleIsActiveChange = (value) => {
    if (value === 'true' || value === 'false') {
      setFilters((prev) => ({ ...prev, is_active: value }))
    } else {
      const { is_active, ...rest } = filters
      setFilters(rest)
    }

    // Réinitialise la pagination
    setPage(1)
    setWorkspaces([])
    setLoading(true) // Set loading to true here
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      handleSearchSubmit()
    }
  }

  const handleResetSearch = () => {
    searchInputRef.current.value = ''
    setSearchQuery('')
    setFilters((prev) => ({
      // Réinitialise le filtre de titre
      ...prev,
      title: '',
    }))
    setPage(1) // Réinitialise la pagination
    setWorkspaces([]) // Vide la liste des workspaces
    setLoading(true) // Active l'indicateur de chargement
  }

  const handleViewModeChange = (mode) => {
    setFilters((prev) => ({
      ...prev,
      view_mode: mode,
    }))

    setPage(1)
    setWorkspaces([])
    setLoading(true)
  }

  const handleSearchSubmit = () => {
    const currentSearchValue = searchInputRef.current.value // Récupère la valeur actuelle

    setSearchQuery(currentSearchValue) // Met à jour l'état pour d'autres utilisations si nécessaire

    setFilters((prev) => ({
      ...prev,
      title: currentSearchValue, // Utilise la valeur actuelle
    }))

    setPage(1)
    setWorkspaces([])
    setLoading(true) // Set loading to true here
  }

  const handleCreateForm = async (url_code) => {
    try {
      const data = await CreateFormFromTemplate(url_code)
      console.log('DATASURPERDATA', data.new_url_code)

      const newUrl = `/sandbox/${data.new_url_code}/`
      history(newUrl)
      // Traitez le résultat si nécessaire
    } catch (error) {
      // Gérez l'erreur si nécessaire
    }
  }

  const DeleteConfirm = ({ onConfirm }) => (
    <Popconfirm
      title="Êtes-vous sûr de vouloir supprimer cet élément?"
      onConfirm={onConfirm}
      okText="Oui"
      cancelText="Non"
    >
      <a href="#">Supprimer</a>
    </Popconfirm>
  )

  const workspaceMenu = (workspace) => [
    {
      label: <a onClick={() => handleDuplicate(workspace)}>Dupliquer</a>,
      key: '1',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cet élément?"
          onConfirm={() => handleDelete(workspace)}
          okText="Oui"
          cancelText="Non"
        >
          <a>Supprimer</a>
        </Popconfirm>
      ),
      key: '2',
    },
  ]

  const handleDuplicate = async (workspace) => {
    try {
      const data = await duplicateFormAPI(workspace.url_code)
      console.log('DATASURPERDATA', data.new_url_code)

      // Trouver le workspace original dans la liste
      const originalWorkspace = workspaces.find(
        (w) => w.url_code === workspace.url_code
      )

      if (originalWorkspace) {
        // Récupérer les informations de l'utilisateur depuis le localStorage avec gestion des erreurs
        const username = getUsernameUser() || 'inconnu'
        const firstName = JSON.parse(localStorage.getItem('first_name')) || ''
        const lastName = JSON.parse(localStorage.getItem('last_name')) || ''

        // Créer l'objet utilisateur pour created_by et updated_by
        const userObject = {
          username: username,
          first_name: firstName,
          last_name: lastName,
        }

        // Créer une copie de l'original en modifiant url_code, id et title_form
        const duplicatedWorkspace = {
          ...originalWorkspace,
          url_code: data.new_url_code,
          id: data.new_url_code, // mettre l'id approprié ici
          title_form: `${originalWorkspace.title_form} Copie (dupliqué)`,
          created_by: userObject,
          updated_by: userObject,
        }

        // Ajouter le nouvel espace de travail dupliqué à la première position de la liste
        setWorkspaces((prevWorkspaces) => [
          duplicatedWorkspace,
          ...prevWorkspaces,
        ])
      }
    } catch (error) {
      console.error('Erreur lors de la duplication:', error)
      // Gérer les erreurs comme vous le souhaitez.
    }
  }

  const handleDelete = async (workspace) => {
    try {
      const data = await deleteFormAPI(workspace.url_code)

      // Mettre à jour la liste locale des workspaces en excluant celui qui vient d'être supprimé
      setWorkspaces((prevWorkspaces) =>
        prevWorkspaces.filter((w) => w.url_code !== workspace.url_code)
      )
    } catch (error) {
      console.error('Erreur lors de la suppression:', error)
      // Gérer les erreurs comme vous le souhaitez.
    }
  }

  const templateContainerRef = useRef(null)

  const searchInputRef = useRef(null)

  const scrollAmount = 366 // C'est le montant que vous souhaitez faire défiler à chaque clic.

  const scrollLeft = (ref) => {
    console.log('scrollLeft is called')
    console.log('current scrollLeft:', ref.current.scrollLeft)
    if (ref && ref.current) {
      ref.current.scrollLeft -= scrollAmount
    }
  }

  const scrollRight = (ref) => {
    console.log('scrollRight is called')
    console.log('current scrollLeft:', ref.current.scrollLeft)
    if (ref && ref.current) {
      ref.current.scrollLeft += scrollAmount
    }
  }

  const renderSkeleton = (
    <div ref={templateContainerRef} className={styles.templateList}>
      <div className={styles.item_carrousel_key}>
        <div className={styles.template__container}>
          <div className={styles.template__item__skeleton}></div>
        </div>
      </div>
      <div className={styles.item_carrousel_key}>
        <div className={styles.template__container}>
          <div className={styles.template__item__skeleton}></div>
        </div>
      </div>
      <div className={styles.item_carrousel_key}>
        <div className={styles.template__container}>
          <div className={styles.template__item__skeleton}></div>
        </div>
      </div>
      <div className={styles.item_carrousel_key}>
        <div className={styles.template__container}>
          <div className={styles.template__item__skeleton}></div>
        </div>
      </div>
      <div className={styles.item_carrousel_key}>
        <div className={styles.template__container}>
          <div className={styles.template__item__skeleton}></div>
        </div>
      </div>
    </div>
  )

  const renderTemplates = (
    <div ref={templateContainerRef} className={styles.templateList}>
      {templates.map((template) => (
        <div
          key={template.id}
          onClick={() => handleCreateForm(template.url_code)}
          className={styles.item_carrousel_key}
        >
          <div className={styles.template__container}>
            <div className={styles.template__item}>
              <div className={styles.de_zoom}>
                <RenderForm
                  DataForm={template}
                  DataFields={template.fields}
                ></RenderForm>
                <div className={styles.disable_interaction}></div>
              </div>
            </div>
          </div>
          {/* Ajout de la div pour l'effet de hover */}
          <div className={styles.hoverOverlay}>Commencer avec ce modèle !</div>
        </div>
      ))}
    </div>
  )

  return (
    <div className={styles.page}>
      <Header isAnswersResponse={false} />

      <div className={styles.search_header}>
        <div className={styles.background_bar}></div>
        <div className={styles.search_bar_details}>
          <div className={styles.search__bar_bloc}>
            <div className={styles.icon_search_bar}>
              <SvgSearchHome />
            </div>

            <input
              type="text"
              placeholder="Rechercher dans vos formulaires..."
              ref={searchInputRef}
              className={styles.search__input}
              onKeyDown={handleKeyDown}
            />

            {searchQuery && (
              <div
                className={styles.icon_clear_search}
                onClick={handleResetSearch}
              >
                <SvgCloseIcon />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.wrap}>
        <div className={styles.bloc__headline}>
          <div className={styles.headline}>Vous aimerez peut-être</div>
          <div className={styles.headline_subtitle}>
            Utilisez un modèle parmi plusieurs formulaires déja prédéfinis.
          </div>
        </div>

        {/* CARROUSEL */}
        <div className={styles.container__caroussel}>
          <button onClick={() => scrollLeft(templateContainerRef)}>
            <SvgGoLeft />
          </button>
          {!loadingTemplate || (loadingTemplate && templates.length === 0)
            ? renderSkeleton
            : renderTemplates}
          <button onClick={() => scrollRight(templateContainerRef)}>
            <SvgGoRight />
          </button>
        </div>

        {/* PARENT FLEX COLOMN */}

        {/* LINE 1 */}
        <div className={styles.bloc__headline}>
          <div className={styles.headline}>
            {searchQuery
              ? `Recherche dans mes formulaires : ${searchQuery}`
              : 'Mes formulaires'}
          </div>

          <div className={styles.headline_subtitle}>
            Liste des formulaires auxquels vous avez accès.
          </div>
        </div>
        {/* LINE 2 */}
        <div className={styles.filter_subnav}>
          <div className={styles.container__filter}>
            <ul className={styles.filter__list}>
              <li
                className={`${styles.category__sets} ${
                  filters.order_by === '-updated_at' ? styles.activeFilter : ''
                }`}
                onClick={() => handleOrderByChange('Du plus récent')}
              >
                Du plus récent
              </li>
              <li
                className={`${styles.category__sets} ${
                  filters.order_by === 'updated_at' ? styles.activeFilter : ''
                }`}
                onClick={() => handleOrderByChange('Du plus ancien')}
              >
                Du plus ancien
              </li>

              {isAdmin && (
                <div>
                  <li
                    className={`${styles.category__sets} ${
                      filters.view_mode === 'viewClassic'
                        ? styles.activeFilter
                        : ''
                    }`}
                    onClick={() => handleViewModeChange('viewClassic')}
                  >
                    Mes formulaires
                  </li>

                  <li
                    className={`${styles.category__sets} ${
                      filters.view_mode === 'viewAdmin'
                        ? styles.activeFilter
                        : ''
                    }`}
                    onClick={() => handleViewModeChange('viewAdmin')}
                  >
                    Tous les formulaires (Admin)
                  </li>
                </div>
              )}

              <li
                className={`${styles.category__sets} ${
                  filters.is_active === 'true' ? styles.activeFilter : ''
                }`}
                onClick={() => handleIsActiveChange('true')}
              >
                Actif
              </li>

              <li
                className={`${styles.category__sets} ${
                  filters.is_active === 'false' ? styles.activeFilter : ''
                }`}
                onClick={() => handleIsActiveChange('false')}
              >
                Inactif
              </li>

              <li
                className={`${styles.category__sets} ${
                  filters.is_active === undefined ? styles.activeFilter : ''
                }`}
                onClick={() => handleIsActiveChange('all')}
              >
                Tous
              </li>

              <li className={styles.category__sets} onClick={handleReset}>
                Réinitialiser
              </li>
            </ul>
          </div>
        </div>
        {/* LINE 3 */}
        <div className={styles.wrap_inner}>
          <div className={styles.content}>
            <div className={styles.main}>
              {loading ? (
                <div className={styles.noFormMessage}>
                  <Spin />
                </div>
              ) : workspaces.length === 0 ? (
                searchQuery ? (
                  <div className={styles.noFormMessage}>
                    Désolé, mais le résultat de votre recherche et de vos
                    filtres ne donne aucun résultat.
                  </div>
                ) : (
                  <div className={styles.noFormMessage}>
                    Vous n'avez accès à aucun formulaire pour le moment.
                    Créez-en un ou demandez-y l'accès.
                  </div>
                )
              ) : (
                <div className={styles.element__grid}>
                  {workspaces.map((workspace, index) => (
                    <div
                      key={workspace.id}
                      className={styles.a__form__container}
                    >
                      <a
                        key={workspace.id}
                        href={
                          workspace.RIGHT__FORM === 'read'
                            ? `/sandbox/${workspace.url_code}/answers/`
                            : `/sandbox/${workspace.url_code}/`
                        }
                        target="_blank"
                        ref={
                          index === workspaces.length - 1
                            ? lastWorkspaceElementRef
                            : null
                        }
                      >
                        <div className={styles.preview__container}>
                          <div className={styles.de_zoom}>
                            <RenderForm
                              DataForm={workspace}
                              DataFields={workspace.fields}
                            ></RenderForm>
                            <div className={styles.disable_interaction}></div>
                          </div>
                        </div>
                      </a>

                      <div className={styles.container__infos}>
                        <div className={styles.container__infos__title}>
                          <Dropdown
                            menu={{ items: workspaceMenu(workspace) }}
                            trigger={['click']}
                          >
                            <div className={styles.dropdownIcon}>
                              <SvgMoreIconCanva />
                            </div>
                          </Dropdown>

                          <div>{workspace.title_form}</div>
                        </div>
                        <div className={styles.container__infos__date}>
                          {workspace.response_count &&
                          workspace.response_count > 0 ? (
                            <div
                              className={
                                styles.badge + ' ' + styles.badge_activ_rep
                              }
                            >
                              {workspace.response_count}
                              {workspace.response_count === 1
                                ? ' réponse'
                                : ' réponses'}
                            </div>
                          ) : (
                            <div className={styles.badge}>0 réponse</div>
                          )}
                          Modifié par {workspace.updated_by.first_name}{' '}
                          {workspace.updated_by.last_name} le{' '}
                          {new Date(workspace.updated_at).toLocaleString(
                            'fr-FR'
                          )}
                        </div>

                        <div className={styles.container__infos__date}>
                          {workspace.is_active ? (
                            <div
                              className={
                                styles.badge + ' ' + styles.badge_activ
                              }
                            >
                              ACTIF
                            </div>
                          ) : (
                            <div className={styles.badge}>INACTIF</div>
                          )}
                          Créé par {workspace.created_by.first_name}{' '}
                          {workspace.created_by.last_name} le{' '}
                          {new Date(workspace.created_at).toLocaleString(
                            'fr-FR'
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Workspaces
